import { useMemo } from "react";
import { useFeatureFlags } from "@/hooks/useFeatureFlag";
import { getDefaultResolvedFeatureFlag } from "@/lib/feature-flag-catalog";

export function useSiteFeatures() {
  const flagsQuery = useFeatureFlags();
  const flags = flagsQuery.data;

  return useMemo(
    () => ({
      ...flagsQuery,
      toofiEnabled: Boolean(flags?.toofi ?? getDefaultResolvedFeatureFlag("toofi")),
      toofiPlansEnabled: Boolean(flags?.toofi_plans ?? getDefaultResolvedFeatureFlag("toofi_plans")),
    }),
    [flags, flagsQuery],
  );
}
